import { render, staticRenderFns } from "./LinkMenu.vue?vue&type=template&id=7fdaa69d&lang=pug&"
import script from "./LinkMenu.vue?vue&type=script&lang=js&"
export * from "./LinkMenu.vue?vue&type=script&lang=js&"
import style0 from "./LinkMenu.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fdaa69d')) {
      api.createRecord('7fdaa69d', component.options)
    } else {
      api.reload('7fdaa69d', component.options)
    }
    module.hot.accept("./LinkMenu.vue?vue&type=template&id=7fdaa69d&lang=pug&", function () {
      api.rerender('7fdaa69d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/schematic/LinkMenu.vue"
export default component.exports